import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation} from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { AbcCore } from "@barthauer/abc/core";
import { Register } from "../models/register.model";
import { UserService } from "../services/user.service";

@Component({
    selector: "abc-register",
    templateUrl: "./register.component.html",
    styleUrls: ["./register.component.scss"],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class RegisterComponent implements OnInit {
  @Output() onSubmit = new EventEmitter<FormGroup>();
  @Input() passwordMinLength = 0;
  public user: Register;
  public form: FormGroup;

  constructor(private abcCore: AbcCore, private userService: UserService) {}

  ngOnInit() {
    this.form = new FormGroup({
      password: new FormControl('', [
      Validators.required,
      Validators.minLength(this.passwordMinLength)
    ]),
      confirmPassword: new FormControl('', Validators.required),
      },
      { validators: this.passwordsMatchValidator }
    );
  }

  private passwordsMatchValidator(group: FormGroup): {[key: string]: boolean;} {
    const password = group.get("password")?.value;
    const confirmPassword = group.get("confirmPassword")?.value;
    return password === confirmPassword ? null : { passwordsMismatch: true };
  }

  public submitForm(): void {
    this.onSubmit.emit(this.form);
    this.form.reset();
  }
}
